import { School } from '../school';
import { Student } from '../student';
import { CardType } from '../card-type';
export class Card {
    constructor(
        public id?: number,
        public validUntil?: any,
        public validSince?: any,
        public maxAssistancesNum?: any,
        public unlimitedClasses?: boolean,
        public usedReservations?: any,
        public price?: number,
        public totalPaid?: number,
        public school?: School,
        public student?: Student,
        public cardType?: CardType,
        public backofficeSessionId?: string,
        public createdDate?: any
    ) {
    }
}

export class CardStats {
    constructor(
        public label?: any,
        public count?: number,
        public totalExpected?: number,
        public avgExpected?: number,
        public totalCollected?: number,
        public avgCollected?: number,
    ) {
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card/card.model.ts